import * as React from 'react';
import usePermission from './usePermission';
import NotPermission from '../StatusPage/NotPermission';

type RestrictedProps = {
  path?: string,
  requiredPermission?: string[],
  children: React.ReactNode | Function,
  fallback?: React.ReactNode,
};

function Restricted({ path, requiredPermission, children, fallback = null }: RestrictedProps) {
  const { hasRoutePermission } = usePermission();

  // 支持自定义渲染方法
  if (typeof children === 'function') {
    return children({ hasRoutePermission });
  }

  // 如果不需要权限检查
  if (!requiredPermission) {
    return <>{children}</>;
  }

  // 检查权限
  const hasPermission =
    (path && hasRoutePermission(path)) ||
    (requiredPermission && requiredPermission.some(permission =>
      hasRoutePermission(permission)
    ));

  if (hasPermission) {
    return <>{children}</>;
  }

  return fallback || <NotPermission />;
}

export default Restricted;
